import React from 'react';
import { PropTypes } from 'prop-types';
import { StyleSheet, Text } from 'react-native';
import Theme from 'Theme';
import { Background } from 'LocalGluons';
import NavigationService from 'NavigationService';

const styles = StyleSheet.create({
    container: {
        flex: 1,
        // backgroundColor: Theme.primaryBackgroundColor,
        justifyContent: 'center',
        alignItems: 'center'
    },
    text: {
        fontFamily: Theme.regularFont,
        fontSize: Theme.primaryFontSize,
        marginHorizontal: 20,
        color: Theme.primaryTextColor,
        justifyContent: 'center',
        alignItems: 'center'
    }
});

class Page extends React.Component {
    componentDidMount() {
        const { navigation } = this.props;
        NavigationService.setAppNavigationInstance(navigation);
    }

    render() {
        return (
            <Background>
                <Text style={styles.text}>My Rentals Browse</Text>
            </Background>
        );
    }
}
Page.propTypes = {
    navigation: PropTypes.shape({}).isRequired
};

export default Page;
